// ONE serial queue for every write that touches the server MailDraft — the
// 2 s autosave (create/update, functions/compose.js) AND the attachment
// staging (functions/attachments.js). They must interleave nowhere: an
// autosave UPDATE echoes the keep-list of staged storagePaths, so one racing
// an in-flight upload would echo a list without the fresh ref and the server
// would drop the blob that just landed. The queue settles even when a step
// throws (steps report their own errors into state; the chain never breaks).
//
// NOT re-exported from the function barrels — an internal primitive, same
// reasoning as ./sameWorkspaceWriter.js.

// The queue's tail starts as `null`, not `Promise.resolve()`: frank carries
// module `let` state in the emitted globalScope's `Smut` holder, which takes
// a literal initial value only - an expression initializer left `_chain`
// unresolvable in the published library (2026-10-07; frank follow-up filed).
// The first write creates the resolved head, so behaviour is unchanged.
let _chain = null

export const enqueueMailComposeWrite = (step) => {
  _chain = (_chain || Promise.resolve()).then(
    () => step(),
    () => step()
  )
  return _chain
}
